/**
 * Helpers de teclado reutilizáveis em formulários (E13.F3). // ux-neutrality:allow doc-comment
 */
import { type KeyboardEvent } from 'react';

function isSingleLetter(key: string): boolean {
  return key.length === 1 && /[A-Za-z]/.test(key);
}

function isUpperLetter(key: string): boolean {
  return key === key.toUpperCase() && key !== key.toLowerCase();
}

function isLowerLetter(key: string): boolean {
  return key === key.toLowerCase() && key !== key.toUpperCase();
}

export function detectCapsLock<T extends HTMLElement>(evt: KeyboardEvent<T>): boolean {
  if (typeof evt.getModifierState === 'function' && evt.getModifierState('CapsLock')) {
    return true;
  }
  const key = evt.key;
  if (!isSingleLetter(key)) return false;
  if (isUpperLetter(key) && !evt.shiftKey) return true;
  if (isLowerLetter(key) && evt.shiftKey) return true;
  return false;
}
